<template>
  <div class="app-main-content">
    <verify-tree-grid
      v-if="!openMultiple"
      v-show="view==='list'"
      ref="verifyTreeGrid"
      :context="context"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @split="splitHandle"
      @copy="copyHandle"
      @refresh="refreshHandle"
    />
    <verify-workspace
      v-show="view==='detail'"
      ref="verifyWorkspace"
      :parent-context="context"
      :open-multiple="openMultiple"
      @add="addHandle"
      @edit="editHandle"
      @copy="copyHandle"
      @back="backToList"
    />
    <job-no-rule-selector
      ref="jobNoRuleSelector"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="jobNoRule.action === 'add' ? doAddJob : doCopyJob"
    />
  </div>
</template>

<script>
import { BookingVerifyContext } from './components/verify/bookingVerifyContext'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import verifyTreeGrid from './components/verify/verifyTreeGrid'
import verifyWorkspace from './components/verify/verifyWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  queryJobNoRule,
  findSeaExportJobByNo,
  isContractExpiredForbidCreateJob,
  doCopyJob,
  queryFmVerify,
  advancedQueryForVerify
} from '@/api/seaExport/seaExportJob'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import lodash from 'lodash'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { JOB_STATES, REMOTE_BOOKING_ALL_STATES } from '@/class/cargo/model/parameters/SystemConstants'
import { JumpUtil } from '@/utils/JumpUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'

export default {
  name: 'BookingVerify',
  components: { verifyTreeGrid, verifyWorkspace, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      openMultiple: Boolean(this.$route.query.openNew && this.$route.query.key), // （组件）打开了多个
      context: BookingVerifyContext.getInstance(),
      view: 'list',
      job: null, // 复制使用
      jobNoRule: {
        visible: false,
        action: 'add',
        rules: ''
      }
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    approveCooperationBusiness() { // 是否协作分公司需审核接单分公司的协作业务
      return this.context.config ? Number(this.context.config.get('approveCooperationBusiness')) === 1 : false
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 首页跳转
      if (to.query.jobNo && to.query.currentOfficeId) {
        vm.toDetailSop(vm, to.query.jobNo)
        return
      }
      // 如果此处需要用到生命周期created内初始化的数据，可能会导致报错
      if (to.query.jobNo) {
        vm.toDetail(vm, to.query.jobNo)
      }
    })
  },
  created() {
    this.context.prepareData()
  },
  async mounted() {
    if (this.openMultiple) {
      this.view = 'detail'
      let rowData = this.$route.params.rowData
      if (!rowData || rowData.length === 0) {
        const loading = getLoading4Cxt(this)
        try {
          const res = await queryFmVerify({ jobNo: this.$route.query.key, branchId: this.$store.getters.currentOfficeId })
          if (res.data.list.length === 0) {
            this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
            return
          }
          rowData = res.data.list
        } catch (err) {
          this.$message.error(this.$t('Message.JumpFailed'))
          throw err
        } finally {
          loading.close()
        }
      }
      rowData = this.getNewDetailData(rowData)
      const selectedRow = rowData.find(p => p.jobNo === this.$route.query.key)
      if (selectedRow) {
        let action = 'look'
        if (this.$route.params.action) {
          action = this.$route.params.action
          delete this.$route.params.action
        }
        if (this.$route.params.activeTabName) {
          this.$refs.verifyWorkspace.activeTabName = this.$route.params.activeTabName
          delete this.$route.params.activeTabName
        }
        this.$refs.verifyWorkspace.onShow(action, rowData, selectedRow)
      }
    }
  },
  activated() {
    if (this.$route.params.jobNos) {
      const filter = {
        conditions: [
          new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', [0, 1, 2, 3], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json(),
          new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json()
        ]
      }
      JumpUtil.jumpToTab(advancedQueryForVerify, filter, this.$route.params, this, 'verifyWorkspace')
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {

    // 查询job后跳转详情
    toDetail(vm, jobNo) {
      const params = {}
      params.branchId = vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      findSeaExportJobByNo(params).then(res => {
        const rowData = res.data.list
        if (rowData) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[0])
          }
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      if (!row) {
        return
      }
      // 协作状态
      if (row.cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        if (row.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code) {
          const cooperateStatusStr = JobUtils.getStateName(row.cooperateStatus, SystemConstants.COOPERATE_STATUS)
          this.$message.warning(this.$t('Message.CanNotEditJob', [this.$t('CargoMsg.Cargo_CooperateStatus') + cooperateStatusStr]))
          return
        }
        this.detailHandle('edit', row)
        return
      }
      const stateStr = JobUtils.getStateName(row.preverifyState, REMOTE_BOOKING_ALL_STATES)
      // 开启，预审状态为待审核、已审核 允许编辑
      const pretrialReviewConfig = parseInt(this.context.config.get('PretrialReview')) === 1
      if (pretrialReviewConfig) {
        if (![1, 2].includes(row.preverifyState)) {
          this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
          return
        }
        if (![-1, 0].includes(row.jobState)) {
          const stateStr = JobUtils.getStateName(row.jobState, JOB_STATES)
          this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
          return
        }
      } else {
        // 不开启，预审状态为待审核的允许编辑
        if (row.preverifyState !== 1) {
          this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
          return
        }
      }
      this.detailHandle('edit', row)
    },
    addHandle() {
      if (!this.checkOfficeId()) return
      this.confirmCallBackHandler('add')
    },
    backToList(isRefresh) {
      if (this.openMultiple) {
        this.$router.push({ name: 'BookingVerify', params: {}})
        return
      }
      if (this.view === 'detail') {
        this.$refs.verifyTreeGrid.$el.style.display = 'flex'
        this.$refs.verifyWorkspace.$el.style.display = 'none'
      }
      const rowData = this.$refs.verifyWorkspace.rowData
      this.view = 'list'
      if (isRefresh) {
        this.$refs.verifyTreeGrid.toQuery(rowData)
      }
    },
    // 复制
    copyHandle(row) {
      if (!row) return
      this.job = row
      if (!this.checkOfficeId()) return
      if (row.customerId) {
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          if (res && res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
            return
          } else {
            this.confirmCallBackHandler('copy')
          }
        })
      }
    },
    doCopyJob(jobNoRule) {
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      item.copyNum = 1
      item.all = false
      item.source = 'bookingVerify'
      this.loading = getLoading()
      doCopyJob(item).then(async res => {
        this.loading.close()
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        newJob.soNo = ''
        newJob.bookingNo = ''
        newJob.returnPeriodBegin = ''
        newJob.returnPeriodEnd = ''
        newJob.fileCutoff = ''
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'BookingVerify')
        if (!continueExec) {
          return
        }
        this.$logger.log('复制-new job', newJob)
        this.detailHandle('copy', newJob)
      })
    },
    confirmCallBackHandler(action) {
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.loading = getLoading()
        queryJobNoRule(SystemConstants.SE.code).then(res => {
          this.loading.close()
          this.ruleResultHandler(res, action)
        })
      } else {
        action === 'copy' ? this.doCopyJob() : this.doAddJob()
      }
    },
    ruleResultHandler(event, action) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.rules = rules
        this.jobNoRule.action = action
        this.jobNoRule.visible = true
      } else if (rules && rules.length > 0) {
        action === 'copy' ? this.doCopyJob(rules[0]) : this.doAddJob(rules[0])
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doAddJob(jobNoRule) {
      this.detailHandle('add', { jobNoRule: !jobNoRule ? '' : jobNoRule.uuid })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.verifyWorkspace.rowData
      } else {
        // rowData = this.$refs.verifyTreeGrid.gridOptions.api.getModel().rowsToDisplay.map(node => node.data)
        rowData = []
        this.$refs.verifyTreeGrid.gridOptions.api.forEachNodeAfterFilterAndSort(node => {
          if (node.data) {
            rowData.push(node.data)
          }
        })
        rowData = this.getNewDetailData(rowData)
        this.view = 'detail'
      }
      if (row.uuid) {
        row = rowData.find(p => p.uuid === row.uuid)
      } else {
        new SeaExportJob(row).fillDefaultValue() // 数据补充完整
        row.version = 0 // 版本号置为0，重新加载job
        row = { ...row } // 需重新构造对象，以便新增加的属性可以被vue监听到
      }
      this.$refs.verifyWorkspace.onShow(type, rowData, row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    // 操作成功后刷新详情
    refreshHandle(row) {
      row.isCompleteRow = false
      this.detailHandle('look', row)
    },
    checkOfficeId() {
      if (!this.office) {
        this.$message.warning(this.$t('Message.CurrentBranchIsNotSelectedCannotAddNewBookings'))
        return false
      }
      if (this.office.officeId === 1) {
        this.$message.warning(this.$t('Message.CompanySelectedIsHQCannotAddNewBookings'))
        return false
      }
      return true
    },
    getNewDetailData(rowData) {
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new SeaExportJob(item).fillDefaultValue() // 数据补充完整
        item.version = 0 // 版本号置为0，重新加载job
      }
      return rowData
    },
    // 首页查询job后跳转详情
    toDetailSop(vm, jobNo) {
      const params = {}
      params.branchId = vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      queryFmVerify(params).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length !== 0) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.verifyWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    }
  }
}
</script>

<style lang="scss">
</style>
